import axios from 'axios';

export default {
  fetchProcedureDirectory({
    commit,
  }, id) {
    return axios.get(`/procedureDirectory/show/${id}`)
      .then((res) => {
        const hiddenFields = {
          fields: res.meta.invisibleFields,
          domain: 'procedureDirectory',
        };

        commit('app/setHiddenFields', hiddenFields, {
          root: true,
        });

        return res;
      });
  },
  copyProcedureDirectory(_, procedureDirectory) {
    return axios.post('/procedureDirectory/copy', procedureDirectory);
  },
  fetchTemplates() {
    return axios.get('/procedureDirectoryTemplate');
  },
  saveProcedureDirectory(_, procedureDirectory) {
    return axios.post('/procedureDirectory', procedureDirectory);
  },
  deleteProcedureDirectory(_, procedureDirectory) {
    console.log(procedureDirectory);

    return axios.delete(`/procedureDirectory/${procedureDirectory.id}`);
  },
};
